import { isSavedAnalysis } from '@modules/analysis/helpers';
import { useRenameAnalysis } from '@modules/analysis/hooks/useRenameAnalysis';
import { useAnalysisStore } from '@modules/analysis/store/analysisStore';
import { ArtefactTitle } from '@modules/common/components/ArtefactTitle';
import { useIsArtefactEditable } from '@modules/common/hooks';
import { ArtefactType } from '@modules/common/types';
import { GoBackToDashboardButton } from '@modules/dashboard/components/GoBackToDashboardButton';
import { useGetQuantifyQueryMetadata } from '@modules/quantify/hooks';
import { useMemo } from 'react';

export const useGetQuantifyLeftActions = () => {
  const analysisMetadata = useGetQuantifyQueryMetadata();
  const handleRenameQuantifyAnalysis = useRenameAnalysis({ analysisMetadata });
  const { title, subtitle, editToken, status, id } = useAnalysisStore(
    ({ title, subtitle, editToken, id, status }) => {
      return {
        id,
        title,
        subtitle,
        editToken,
        status,
      };
    },
  );

  const isEditable = useIsArtefactEditable({
    editToken,
    status,
  });

  const canRenameQuantify = isEditable && isSavedAnalysis(id);

  const leftActions = useMemo(
    () => [
      {
        component: <GoBackToDashboardButton />,
        key: 'Back Button',
      },
      {
        component: (
          <ArtefactTitle
            name={title}
            artefactType={ArtefactType.Quantify}
            onArtefactRename={
              canRenameQuantify ? handleRenameQuantifyAnalysis : undefined
            }
            createdBy={subtitle}
          />
        ),
        key: 'Save Analysis View',
      },
    ],
    [canRenameQuantify, handleRenameQuantifyAnalysis, subtitle, title],
  );

  return leftActions;
};
